import Bugsnag from '@bugsnag/js';

export const setUser = (userId: string) => {
  Bugsnag.setUser(userId);
};

export default Bugsnag;
